export const slotBarSymbolNames = {
  icon1: 'icon1',
  icon2: 'icon2',
  icon3: 'icon3',
  icon4: 'icon4',
  icon5: 'icon5',
  icon6: 'icon6',
  icon7: 'icon7',
  icon8: 'icon8',
  icon9: 'icon9',
  icon10: 'icon10',
  icon11: 'icon11',
  icon12: 'jackPotIcon',
};

export const slotSpineKey = {
  1: slotBarSymbolNames.icon1,
  2: slotBarSymbolNames.icon2,
  3: slotBarSymbolNames.icon3,
  4: slotBarSymbolNames.icon4,
  5: slotBarSymbolNames.icon5,
  6: slotBarSymbolNames.icon6,
  7: slotBarSymbolNames.icon7,
  8: slotBarSymbolNames.icon8,
  9: slotBarSymbolNames.icon9,
  10: slotBarSymbolNames.icon10,
  11: slotBarSymbolNames.icon11,
  400: slotBarSymbolNames.icon12,
  popup: 'popup',
  mainBg: 'mainBg',
  winCoin: 'winCoin',
  loading: 'loading',
  winLine: 'winLine',
  winPopup: 'winPopup',
  gameLogo: 'gameLogo',
  lightning: 'lightning',
  wheelIcon: 'wheelIcon',
  wheelLamp: 'wheelLamp',
  gambleCard: 'gambleCard',
  jackPotItem: 'jackPotItem',
  gambleSymbol: 'gambleSymbol',
  jackPotSymbol: 'jackPotSymbol',
  wheelSpinIcon: 'wheelSpinIcon',
  wheelBlueBoard: 'wheelBlueBoard',
  jackpotWinPopup: 'jackpotWinPopup',
  jackpotBackGroundLogo: 'jackpotBackGroundLogo',
  jackpotBackGroundStage: 'jackpotBackGroundStage',
  jackpotBackGroundStars: 'jackpotBackGroundStars',
  jackpotBackGroundProjector: 'jackpotBackGroundProjector',
  jackpotBackGroundLights: 'jackpotBackGroundLights',
  gambleAmountFrame: 'gambleAmountFrame',
  jackpotAmountBoard: 'jackpotAmountBoard',
  jackpotCongratsPopup: 'jackpotCongratsPopup',
  jackpotGameSceneBoard: 'jackpotGameSceneBoard',
  winFrame: 'winFrame',
};

export const slotIconsKey = {
  1: slotBarSymbolNames.icon1,
  2: slotBarSymbolNames.icon2,
  3: slotBarSymbolNames.icon3,
  4: slotBarSymbolNames.icon4,
  5: slotBarSymbolNames.icon5,
  6: slotBarSymbolNames.icon6,
  7: slotBarSymbolNames.icon7,
  8: slotBarSymbolNames.icon8,
  9: slotBarSymbolNames.icon9,
  10: slotBarSymbolNames.icon10,
  11: slotBarSymbolNames.icon11,
};

export const randomGeneratedIcons = [
  '4',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '4',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
];

export const randomGeneratedIconsWithSeven = [
  '4',
  '1',
  '1',
  '1',
  '4',
  '5',
  '4',
  '8',
  '1',
  '1',
  '1',
  '4',
  '1',
];

export const randomGeneratedIconsWithSevenOneLine = [
  '1',
  '4',
  '7',
  '4',
  '5',
  '4',
  '7',
  '7',
  '3',
  '7',
  '3',
  '5',
  '4',
  '6',
];

export const randomGeneratedIconsWithSevenTwoLine = [
  '2',
  '1',
  '1',
  '3',
  '4',
  '5',
  '4',
  '8',
  '8',
  '4',
  '7',
  '3',
  '5',
  '4',
  '1',
];

export const randomIconsGroup = [
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIconsWithSevenTwoLine,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIconsWithSevenOneLine,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIconsWithSevenOneLine,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIconsWithSevenOneLine,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIconsWithSeven,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIconsWithSevenTwoLine,
];

export const iconsIdByName = {
  [slotBarSymbolNames.icon1]: 1,
  [slotBarSymbolNames.icon2]: 2,
  [slotBarSymbolNames.icon3]: 3,
  [slotBarSymbolNames.icon4]: 4,
  [slotBarSymbolNames.icon5]: 5,
  [slotBarSymbolNames.icon6]: 6,
  [slotBarSymbolNames.icon7]: 7,
  [slotBarSymbolNames.icon8]: 8,
  [slotBarSymbolNames.icon9]: 9,
  [slotBarSymbolNames.icon10]: 10,
  [slotBarSymbolNames.icon11]: 11,
  [slotBarSymbolNames.icon12]: 400,
};
export const specialIconKeys = {
  wild: 9,
  scatter1: 10,
  scatter2: 11,
};
export const iconStates = {
  win: 'win',
  idle: 'idle',
  blur: 'blur',
  noWin: 'noWin',
  winExpand: {
    wildUp: 'wildWeedUp',
    wildCenter: 'wildWeedCenter',
    wildDw: 'wildWeedDw',
  },
  idleExpand: {
    wildUp: 'idleBigUp',
    wildCenter: 'idleBigCenter',
    wildDw: 'idleBigDw',
  },
};

export const spineNames = {
  bg: 'backGround',
};
